import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logoImage from '../assets/images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/" onClick={closeMenu}>
              <img src={logoImage} alt="Sipelius kotipalvelu logo - Kotisiivous ja senioriapu Lahdessa" />
            </Link>
          </div>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li>
                <Link 
                  to="/" 
                  className={isActive('/') ? 'active' : ''}
                  onClick={closeMenu}
                >
                  Esittely
                </Link>
              </li>
              <li>
                <Link 
                  to="/palvelut" 
                  className={isActive('/palvelut') ? 'active' : ''}
                  onClick={closeMenu}
                >
                  Palvelut
                </Link>
              </li>
              <li>
                <Link 
                  to="/hinnasto" 
                  className={isActive('/hinnasto') ? 'active' : ''}
                  onClick={closeMenu}
                >
                  Hinnasto
                </Link>
              </li>
              <li>
                <Link 
                  to="/yhteystiedot" 
                  className={isActive('/yhteystiedot') ? 'active' : ''}
                  onClick={closeMenu}
                >
                  Yhteystiedot
                </Link>
              </li>
            </ul>
          </nav>

          <button 
            className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? "Sulje valikko" : "Avaa valikko"}
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 